module.exports = __webpack_public_path__ + "img/tick-queued.d078db54.svg";